export const NAME = 'reports';